/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference;
(function (FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference) {
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference[FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference["Low"] = 0] = "Low";
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference[FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference["Medium"] = 1] = "Medium";
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference[FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference["High"] = 2] = "High";
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference[FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference || (FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference = {}));
export function instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference(value) {
    for (const key in FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference, key)) {
            if (FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceToJSON(value) {
    return value;
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference.js.map